/* Bright Futures Counseling: "Get a quote by email" (2026-10).
   Replaces the Purchase Orders app quote form. Posts the cart (or given lines) to the impact-bot, which
   creates a numbered Shopify draft order estimate and emails it with a PDF, the W-9, a card checkout
   button and the PO link. Used by the cart drawer, cart page, wishlist, approval page and schools page.
   API: BFCEstimate.open(opts)   opts: { lines:[{v,q,license,title}], source, school, name, email, licenseEmails, note, requestedBy }
        BFCEstimate.send(payload) -> Promise<{ ok, number, total, page, pdf }> */
(function () {
  if (window.BFCEstimate) return;
  var BOT = (window.BFC_EST_CFG && window.BFC_EST_CFG.bot) || 'https://impact-bot-production.up.railway.app';
  var LICENSE_TYPE = 'IMPACT School License';
  var EMAIL_RE = /^[^\s@<>()",;:]+@[^\s@<>()",;:]+\.[a-z]{2,}$/i;
  var STORE_KEY = 'bfc-est-contact';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(n) { return '$' + (Number(n) || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function emails(s) { var out = []; String(s || '').split(/[\s,;]+/).forEach(function (e) { e = e.trim().toLowerCase(); if (EMAIL_RE.test(e) && out.indexOf(e) < 0) out.push(e); }); return out; }
  function loadContact() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function saveContact(c) { try { localStorage.setItem(STORE_KEY, JSON.stringify(c)); } catch (e) {} }

  function send(payload) {
    return fetch(BOT + '/bfc/estimate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }).then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || 'Something went wrong. Please email payments@brightfutures-counseling.com.'); return j; }); });
  }

  function cartLines() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      return {
        attrs: c.attributes || {},
        lines: (c.items || []).map(function (i) { return { v: i.variant_id, q: i.quantity, license: i.product_type === LICENSE_TYPE, title: i.product_title }; })
      };
    });
  }

  var css = '.bfc-est{position:fixed;inset:0;z-index:2147483001;display:flex;align-items:flex-start;justify-content:center;padding:5vh 16px;background:rgba(20,20,28,.55);overflow-y:auto;font-family:inherit}' +
    '.bfc-est__panel{position:relative;width:100%;max-width:520px;padding:28px 26px 24px;border-radius:14px;background:#fff;color:#202020;box-shadow:0 20px 60px rgba(0,0,0,.3);text-align:left}' +
    '.bfc-est__x{position:absolute;top:10px;right:12px;width:36px;height:36px;border:0;background:none;color:#555;font-size:26px;line-height:1;cursor:pointer}' +
    '.bfc-est h2{margin:0 36px 8px 0;color:#202020;font-size:22px;line-height:1.25;text-transform:none;letter-spacing:0}' +
    '.bfc-est p{margin:0 0 12px;font-size:15px;line-height:1.55;color:#3a3a3a}' +
    '.bfc-est label{display:block;margin:0 0 12px;font-size:13.5px;font-weight:700;color:#202020;text-transform:none;letter-spacing:0}' +
    '.bfc-est label small{display:block;margin-top:3px;color:#666;font-size:12.5px;font-weight:400}' +
    '.bfc-est label em{color:#666;font-style:normal;font-weight:400}' +
    '.bfc-est input,.bfc-est textarea{display:block;width:100%;margin:5px 0 0;padding:9px 11px;border:1px solid #cfd0da;border-radius:7px;background:#fff;color:#202020;font:inherit;font-size:15px;font-weight:400;box-sizing:border-box}' +
    '.bfc-est textarea{min-height:64px;resize:vertical}' +
    '.bfc-est__row{display:grid;grid-template-columns:1fr 1fr;gap:0 12px}@media (max-width:520px){.bfc-est__row{grid-template-columns:1fr}}' +
    '.bfc-est__btn{box-sizing:border-box;display:flex;align-items:center;justify-content:center;width:100%;min-height:48px;margin:6px 0 0;padding:10px 16px;border:0;border-radius:8px;background:#d10fb6;color:#fff!important;font:inherit;font-size:15px;font-weight:700;letter-spacing:.4px;text-transform:uppercase;text-decoration:none!important;cursor:pointer}' +
    '.bfc-est__btn[disabled]{opacity:.6;cursor:wait}' +
    '.bfc-est__btn--ghost{background:#fff;border:1.5px solid #d10fb6;color:#d10fb6!important}' +
    '.bfc-est__status{min-height:1px;margin:10px 0 0;font-size:14px;color:#b00020}' +
    '.bfc-est__items{margin:0 0 14px;padding:10px 12px;border-radius:8px;background:#f6f6f9;font-size:13.5px;line-height:1.5;color:#3a3a3a}' +
    '.bfc-est__links{display:grid;gap:8px;margin:14px 0 0}' +
    '.bfc-est__fine{margin-top:14px!important;font-size:13px!important;color:#666!important}';

  function ensureCss() {
    if (document.getElementById('bfc-est-css')) return;
    var s = document.createElement('style'); s.id = 'bfc-est-css'; s.textContent = css; document.head.appendChild(s);
  }

  var openEl = null, lastFocus = null;
  function close() {
    if (!openEl) return;
    openEl.remove(); openEl = null; document.removeEventListener('keydown', onKey, true);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }
  function onKey(e) { if (e.key === 'Escape') { e.preventDefault(); close(); } }

  function render(opts, lines, attrs) {
    ensureCss(); close();
    lastFocus = document.activeElement;
    var saved = loadContact();
    var cust = (window.BFCWL_CFG && window.BFCWL_CFG.customer) || {};
    var seats = 0, items = 0;
    lines.forEach(function (l) { items += l.q; if (l.license) seats += l.q; });
    var resources = items - seats;
    var what = [];
    if (resources) what.push(resources + (resources === 1 ? ' resource' : ' resources'));
    if (seats) what.push(seats + ' IMPACT ' + (seats === 1 ? 'license' : 'licenses'));
    var v = {
      email: opts.email || saved.email || cust.email || '',
      name: opts.name || saved.name || cust.name || '',
      school: opts.school || attrs.School || saved.school || '',
      lic: opts.licenseEmails || attrs['License emails'] || '',
      note: opts.note || ''
    };
    var el = document.createElement('div');
    el.className = 'bfc-est';
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'bfc-est-title');
    el.innerHTML = '<div class="bfc-est__panel">' +
      '<button type="button" class="bfc-est__x" aria-label="Close" data-x>&times;</button>' +
      '<div data-step="form">' +
        '<h2 id="bfc-est-title">Get a quote by email</h2>' +
        '<p>I\'ll email you a numbered estimate with a PDF and my W-9, ready for your business office. When your PO is approved, the same email has a link to place the order with your PO number.</p>' +
        (what.length ? '<p class="bfc-est__items">This estimate includes ' + esc(what.join(' and ')) + '.</p>' : '') +
        '<form novalidate>' +
          '<div class="bfc-est__row">' +
            '<label>Your email<input type="email" name="email" required autocomplete="email" maxlength="120" value="' + esc(v.email) + '"></label>' +
            '<label>Your name <em>(optional)</em><input type="text" name="name" autocomplete="name" maxlength="80" value="' + esc(v.name) + '"></label>' +
          '</div>' +
          '<label>School or district <em>(optional)</em><input type="text" name="school" autocomplete="organization" maxlength="120" value="' + esc(v.school) + '"></label>' +
          (seats ? '<label>Counselor emails for the ' + (seats === 1 ? 'license' : seats + ' licenses') + ' <em>(optional)</em><textarea name="licenseEmails" rows="2" maxlength="2000" placeholder="name@school.org, name2@school.org">' + esc(v.lic) + '</textarea><small>Each counselor gets IMPACT access once the order is placed. You can add or change these later.</small></label>' : '') +
          '<label>Note for the business office <em>(optional)</em><textarea name="note" rows="2" maxlength="400">' + esc(v.note) + '</textarea></label>' +
          '<button type="submit" class="bfc-est__btn">Email my quote</button>' +
          '<p class="bfc-est__status" role="status" aria-live="polite" data-status></p>' +
        '</form>' +
      '</div>' +
      '<div data-step="done" hidden>' +
        '<h2>Your estimate is on its way</h2>' +
        '<p data-done-msg></p>' +
        '<div class="bfc-est__links"><a class="bfc-est__btn" data-done-page target="_blank" rel="noopener">View the estimate</a><a class="bfc-est__btn bfc-est__btn--ghost" data-done-pdf target="_blank" rel="noopener">Download the PDF</a></div>' +
        '<p class="bfc-est__fine">Paying by card? The email has a checkout button. Paying with a PO? Use the link in the email once it\'s approved. Questions or vendor forms: payments@brightfutures-counseling.com</p>' +
      '</div>' +
    '</div>';
    if (!lines.length) el.querySelector('[data-step="form"]').innerHTML = '<h2 id="bfc-est-title">Your cart is empty</h2><p>Add the resources you need to your cart, then come back here for a quote.</p>';
    document.body.appendChild(el); openEl = el;
    document.addEventListener('keydown', onKey, true);
    el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('[data-x]')) close(); });
    if (!lines.length) return;
    var form = el.querySelector('form'), st = el.querySelector('[data-status]'), btn = form.querySelector('button[type="submit"]');
    var first = form.querySelector(v.email ? '[name="school"]' : '[name="email"]'); if (first) first.focus();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = {}; Array.prototype.forEach.call(form.elements, function (i) { if (i.name) f[i.name] = i.value.trim(); });
      if (!EMAIL_RE.test(f.email || '')) { st.textContent = 'Please enter a valid email address.'; form.email.focus(); return; }
      if (seats && f.licenseEmails) {
        var n = emails(f.licenseEmails).length;
        if (n > seats) { st.textContent = 'There ' + (seats === 1 ? 'is 1 license' : 'are ' + seats + ' licenses') + ' on this estimate. Please list up to ' + seats + ' counselor email' + (seats === 1 ? '' : 's') + '.'; form.licenseEmails.focus(); return; }
      }
      saveContact({ email: f.email, name: f.name, school: f.school });
      st.textContent = ''; btn.disabled = true; btn.textContent = 'Sending...';
      send({
        email: f.email, name: f.name, school: f.school, licenseEmails: f.licenseEmails || '', note: f.note,
        requestedBy: opts.requestedBy || attrs['Requested by'] || '', source: opts.source || 'Website',
        lines: lines.map(function (l) { return { v: l.v, q: l.q }; })
      }).then(function (r) {
        el.querySelector('[data-step="form"]').hidden = true;
        var done = el.querySelector('[data-step="done"]'); done.hidden = false;
        el.querySelector('[data-done-msg]').textContent = 'Estimate ' + r.number + ' for ' + money(r.total) + ' was emailed to ' + f.email + '. It can take a few minutes to arrive, so check your spam folder if you don\'t see it.';
        el.querySelector('[data-done-page]').href = r.page;
        el.querySelector('[data-done-pdf]').href = r.pdf;
        el.querySelector('[data-done-page]').focus();
        if (typeof opts.onDone === 'function') opts.onDone(r);
      }, function (err) {
        btn.disabled = false; btn.textContent = 'Email my quote';
        st.textContent = err.message;
      });
    });
  }

  function open(opts) {
    opts = opts || {};
    if (opts.lines && opts.lines.length) { render(opts, opts.lines, {}); return; }
    cartLines().then(function (c) {
      render(opts, c.lines, c.attrs);
    }, function () { window.location.href = 'mailto:payments@brightfutures-counseling.com?subject=' + encodeURIComponent('Quote request'); });
  }

  window.BFCEstimate = { open: open, send: send, close: close, emails: emails };
})();
